// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import store from './store'
import {i18n} from './i18n'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '../theme/index.css'
import App from './App'
import router from './router'
import { newClient } from './api/axios-client-factory'
import VueClipboard from 'vue-clipboard2';
//import Axios from 'axios'
//导入需要全局暴露的过滤器
import filters from "./utils/filters";

Vue.use(ElementUI,{
  i18n:(key,value)=>i18n.t(key,value)
})
Vue.use(Vant);


//全局注册过滤器
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(ElementUI);
Vue.prototype.newClient=newClient;


//设置语言
store.commit("setLanguage");
// 只能输入数字
Vue.prototype.$num=(value)=>{
  return value.replace(/\D/g,'')
}
// 禁止输入数字
Vue.prototype.$notNum=(value)=>{
  return value.replace(/\d/g,'')
}

//Axios.defaults.baseURL = global_huanjing.apiUrl;
// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    const userInfo = store.state.userInfo;
    // console.log(userInfo);
    if (userInfo&&userInfo.token !== null && typeof userInfo.token !== 'undefined' && userInfo.token.toString().trim() !== '') {

    const status = store.state.userInfo.status;
    console.log(status);
     if(status==3){
      next()
     }else if (to.path === '/apply'){
      next()
     }else{
        next('/apply')
      }
    } else {
      // token无效, 重新登录!
      next({
        path: '/login',
        query: {
          code: 401,
          returnUrl: from.path
        }
      })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js